<script>
export default {
    name: 'ToastHandler',

    data() {
        return {
            myToast: {},
            position: 'bottom-right',
            theme: 'toasted-primary',
            message: '',
        }
    },

    methods: {
        showSearchingToast() {
            this.myToast = this.$toasted.info('Recherche en cours', {
                icon: {
                    name: 'search',
                },
                theme: this.theme,
                position: this.position,
                className: ['info-toast'],
            })
        },

        showRecordingToast() {
            this.myToast = this.$toasted.info('Enregistrement en cours', {
                icon: {
                    name: 'save',
                },
                theme: this.theme,
                position: this.position,
                className: ['info-toast'],
            })
        },

        showDeletingToast() {
            this.myToast = this.$toasted.info('Suppression en cours', {
                icon: {
                    name: 'delete',
                },
                theme: this.theme,
                position: this.position,
                className: ['info-toast'],
            })
        },

        showSendingToast() {
            this.myToast = this.$toasted.info('Envoi en cours', {
                icon: {
                    name: 'email',
                },
                theme: this.theme,
                position: this.position,
                className: ['info-toast'],
            })
        },

        showDownloadingToast() {
            this.myToast = this.$toasted.info(
                'Récupération des données en cours',
                {
                    icon: {
                        name: 'cloud_downloading',
                    },
                    theme: this.theme,
                    position: this.position,
                    className: ['info-toast'],
                }
            )
        },

        showSuccessToast(message) {
            this.myToast = this.$toasted.info(message, {
                icon: {
                    name: 'sentiment_satisfied_alt',
                },
                theme: this.theme,
                position: this.position,
                duration: 3000,
                className: ['success-toast'],
            })
        },

        showErrorToast(status) {
            if (status === 403) {
                this.message = "Vous n'êtes pas autorisé·e à faire cette action"
            } else if (status === 401) {
                this.message = "Erreur d'authentification sur le serveur"
            } else if (status === 500) {
                this.message = "Une erreur s'est produite sur le serveur"
            } else {
                this.message = "Une erreur s'est produite"
            }

            this.myToast = this.$toasted.info(this.message, {
                icon: {
                    name: 'sentiment_very_dissatisfied',
                },
                theme: this.theme,
                position: this.position,
                duration: 5000,
                className: ['error-toast'],
            })
        },

        showWarningToast(message) {
            this.myToast = this.$toasted.info(message, {
                icon: {
                    name: 'sentiment_dissatisfied',
                },
                theme: this.theme,
                position: this.position,
                duration: 5000,
                className: ['warning-toast'],
            })
        },

        showSuccessOrWarningToast(meta) {
            if (meta.warning) {
                this.showWarningToast(meta.message)
            } else {
                this.showSuccessToast(meta.message)
            }
        },

        closeToast() {
            this.myToast.goAway(700)
        },

        closeDeletingToast() {
            this.closeToast()
        },

        closeSendingToast() {
            this.closeToast()
        },

        closeRecordingToast() {
            this.closeToast()
        },

        handleWarning(message) {
            this.closeToast()
            this.showWarningToast(message)
        },

        handleSuccess(message) {
            this.closeToast()
            this.showSuccessToast(message)
        },

        handleErrors(status) {
            this.closeToast()
            this.showErrorToast(status)
        },
    },
}
</script>
